export const messages = {
  empty: {
    description: {
      id: 'admin/promotions.form.buy-and-win.trigger.empty.description',
    },
    addItems: {
      id: 'admin/promotions.form.utils.add-items',
    },
  },
  description: {
    id: 'admin/promotions.form.buy-and-win.trigger.description',
  },
  descriptionEquals: {
    id: 'admin/promotions.form.buy-and-win.trigger.description.equals',
  },
  collections: {
    id: 'admin/promotions.form.buy-and-win.trigger.collections',
  },
  skus: {
    id: 'admin/promotions.form.buy-and-win.trigger.skus',
  },
  editor: {
    title: {
      id: 'admin/promotions.form.buy-and-win.trigger.editor.title',
    },
    minQuantity: {
      id: 'admin/promotions.form.buy-and-win.trigger.editor.min-quantity',
    },
    sameItemsOnly: {
      id: 'admin/promotions.form.utils.items.same-items-only',
    },
  },
  validation: {
    itemsRequired: {
      id: 'admin/promotions.form.skus-collections.validation.required',
    },
    fieldRequired: { id: 'admin/promotions.form.validation.required' },
    minQuantityMinValue: {
      id: 'admin/promotions.form.validation.greater-than-equals',
    },
  },
  apply: {
    id: 'admin/promotions.utils.apply',
  },
  cancel: { id: 'admin/promotions.utils.cancel' },
}
